/* eslint-disable import/extensions */
/* eslint-disable notice/notice */

export default {

}
